import { BuildVariables } from "Build.Common/Scripts/Generated/TFS.Build2.Common";

export let defaultSourceLabelFormat = "$(" + BuildVariables.BuildNumber + ")";